const initialState = {
    loggedIn: false,
    userName: "",
}

export default function api(state = initialState, action) {
    switch(action.type) {
        case "SET_LOGGEDIN":
            return {
                ...state,
                loggedIn: action.loggedIn,
                userName: action.userName,
            }
        default:
            return state;
    }
}
